import React from "react";
import { Tooltip, Typography } from "@mui/material";
import dayjs, { parseIsoOrUsDate } from "utils/dayjs";
import { useTranslation } from "react-i18next";

interface RenderDateWithPopupProps {
  inputDate: Date | string | null | undefined; // The due date
  paidDate?: Date | string | null | undefined; // The date the invoice was paid
}

const RenderDateWithPopup: React.FC<RenderDateWithPopupProps> = ({
  inputDate,
  paidDate,
}) => {
  const { t } = useTranslation();

  if (!inputDate || isNaN(new Date(inputDate).getTime())) {
    return <Typography variant="body2">{t("N/A")}</Typography>;
  }

  const dueDate = parseIsoOrUsDate(inputDate).endOf("day"); // Convert timestamp to Date object
  const formattedDueDate = dayjs(dueDate).format("MM/DD/YYYY");

  // Determine if the invoice is late or paid late
  const isLate = dayjs().startOf("day").isAfter(dayjs(dueDate).startOf("day"));
  const wasPaidLate =
    paidDate &&
    dayjs(paidDate).startOf("day").isAfter(dayjs(dueDate).startOf("day"));

  // Determine the tooltip text and display text
  let tooltipText = "";

  if (paidDate) {
    const formattedPaidDate = dayjs(paidDate).format("MM/DD/YYYY");
    if (wasPaidLate) {
      tooltipText = `${t("Paid late on")} ${formattedPaidDate}`;
    } else {
      tooltipText = `${t("Paid on time on")} ${formattedPaidDate}`;
    }
  } else if (isLate) {
    tooltipText = t("Due {{fromNow}}", { fromNow: dayjs(dueDate).fromNow() });
  } else {
    tooltipText = t("Due {{fromNow}}", { fromNow: dayjs(dueDate).fromNow() });
  }

  return (
    <Tooltip title={tooltipText}>
      <Typography variant="body2">{formattedDueDate}</Typography>
    </Tooltip>
  );
};

export default RenderDateWithPopup;
